import React, { useEffect, useState } from "react";

export const TypingLabel = ({ text, speed, style, blinkingCursor }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [showCursor, setShowCursor] = useState(false);

    useEffect(() => {
        if (displayedText.length < text.length) {
            const timeoutId = setTimeout(() => {
                setDisplayedText(text.slice(0, displayedText.length + 1));
            }, speed);
            return () => clearTimeout(timeoutId);
        }
    }, [text, speed, displayedText]);

    useEffect(() => {
        if (blinkingCursor) {
            const cursorInterval = setInterval(() => {
                setShowCursor(prev => !prev);
            }, 500); // Toggle cursor every 500ms (0.5 seconds)
            return () => clearInterval(cursorInterval);
        }
    }, [blinkingCursor]);

    return (
        <span style={style}>
            {displayedText}
            {blinkingCursor && showCursor && ' |'}
        </span>
    );
};